'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../styleInject.js');

var css_248z = ".ClaimsList-module_claimsList__3OmrE{box-sizing:border-box;list-style:none;margin:0;padding:0;width:100%}";
var styles = {"claimsList":"ClaimsList-module_claimsList__3OmrE"};
styleInject["default"](css_248z, '15277b47-875d-4b12-8c9b-be87dbd42384');

exports["default"] = styles;
